const api = {
	url: process.env.REACT_APP_API_URL,
};

export default api;
